import uuid from 'uuid/v4';

export function getUuid4(): string {
    return uuid();
}
